<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-wrench
      </v-icon>
      Support Tickets
    </h2>
    <br>
    <v-tabs
      v-model="tab"
      color="#FF3700"
      background-color="#ECEFF1"
    >
      <v-tab
        v-for="(item, index) in appModules"
        :key="index"
        @click="fetchClickedAppModuleTickets(item.name)"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <support-tickets ref="appModuleTickets" />
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import SupportTickets from './SupportTickets.vue';

  export default {
    name: 'SupportLandingPage',
    components: {
      'centre-spinner': spinner,
      'support-tickets': SupportTickets,
    },
    data: () => ({
      tab: null,
      currentActiveTab: '',
      loading: false,
    }),
    computed: {
      appModules () {
        return this.$store.getters['organizations/getAppModules'];
      },
      isAppModuleExists () {
        return this.appModules.length > 0;
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchAppModules();
      this.loading = false;
    },
    methods: {
      async fetchAppModules () {
        this.loading = true;
        await this.$store.dispatch('organizations/fetchAppModules').then(() => {
          this.fetchCurrentTabAppModuleTickets();
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      fetchCurrentTabAppModuleTickets () {
        this.loading = true;
        this.currentActiveTab = this.appModules[0].name;
        this.$refs.appModuleTickets.fetchAppModuleTickets(this.currentActiveTab);
        this.loading = false;
      },
      async fetchClickedAppModuleTickets  (val) {
        this.$refs.appModuleTickets.fetchAppModuleTickets(val);
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-left: 20px;
}
.my-tabs-background-style {
    background-color: #ECEFF1 !important;
}
.app-modules {
  padding-top: 50px;
  padding-bottom: 50px;
}
.my-alert-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
